import { AfterContentInit, Component, OnInit } from '@angular/core';
import { fadeInUp400ms } from 'src/@vex/animations/fade-in-up.animation';
import { stagger40ms } from 'src/@vex/animations/stagger.animation';
import { Link } from 'src/@vex/interfaces/link.interface';
import { trackByRoute } from 'src/@vex/utils/track-by';

declare var hbspt: any;

@Component({
  selector: 'vex-help-center',
  templateUrl: './help-center.component.html',
  styleUrls: ['./help-center.component.scss'],
  animations: [
    stagger40ms,
    fadeInUp400ms
  ]
})
export class HelpCenterComponent implements OnInit, AfterContentInit {

  links: (Link & { icon: string })[] = [
    {
      label: 'Getting Started',
      route: 'getting-started',
      icon: 'mat:flag'
    },
    {
      label: 'Pricing & Plans',
      route: 'pricing',
      icon: 'mat:attach_money'
    },
    {
      label: 'FAQ',
      route: 'faq',
      icon: 'mat:contact_support'
    },
    {
      label: 'Guides',
      route: 'guides',
      icon: 'mat:book'
    }
  ];

  trackByRoute = trackByRoute;

  constructor() { }

  ngAfterContentInit(): void {
    hbspt.forms.create({ 
      region: "na1", 
      portalId: "22084976", 
      formId: "91f603fb-ce3b-4564-a9cc-81cd0799ef5b", 
      target: "#hubspotForm" 
    }); 
  }

  ngOnInit() {
  }

}